/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { userSessionIssuersGet } from "../funcs/userSessionIssuersGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { UserSessionIssuer } from "../models/components/usersessionissuer.js";
import {
  GetUserSessionIssuerRequest,
  GetUserSessionIssuerSecurity,
} from "../models/operations/getusersessionissuer.js";
import { unwrapAsync } from "../types/fp.js";
export type UserSessionIssuerQueryData = UserSessionIssuer;

export function prefetchUserSessionIssuer(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetUserSessionIssuerRequest | undefined,
  security?: GetUserSessionIssuerSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildUserSessionIssuerQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildUserSessionIssuerQuery(
  client$: GramCore,
  request?: GetUserSessionIssuerRequest | undefined,
  security?: GetUserSessionIssuerSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<UserSessionIssuerQueryData>;
} {
  return {
    queryKey: queryKeyUserSessionIssuer({
      id: request?.id,
      slug: request?.slug,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function userSessionIssuerQueryFn(
      ctx,
    ): Promise<UserSessionIssuerQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(userSessionIssuersGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyUserSessionIssuer(
  parameters: {
    id?: string | undefined;
    slug?: string | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "userSessionIssuers", "get", parameters];
}
